import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetFilter } from "../../features/filter/filterSlice";
import { fetchTags } from "./../../features/tags/tagsSlice";
import Tag from "./Tag";

const TagContainer = () => {
  const dispatch = useDispatch();
  const { tags } = useSelector((state) => state.tags);

  useEffect(() => {
    dispatch(fetchTags());
  }, [dispatch]);

  const handleReset = () => {
    dispatch(resetFilter());
  };
  return tags?.length > 0 ? (
    <section>
      <div className='max-w-7xl mx-auto flex flex-row gap-4 px-4 items-center justify-between'>
        <div className=' px-5 py-6 lg:px-0 flex gap-2 wp border-b overflow-y-auto'>
          {tags.map((tag) => (
            <Tag title={tag.title} key={tag.id}></Tag>
          ))}
        </div>

        <button onClick={handleReset} className='px-4 py-1 rounded-full cursor-pointer bg-orange-600 text-white'>
          reset
        </button>
      </div>
    </section>
  ) : null;
};

export default TagContainer;
